import {Box, Button, CircularProgress} from '@material-ui/core';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import React from 'react';
import {useCommonModalStyles} from '@/Agent/Quotes/InstantAppModalPages/common/modalStyles';

type FixedNavigationProps = {
    onBack?: () => void;
    isBackDisabled?: boolean;
    isNextDisabled?: boolean;
    onNext?: () => void;
    isLoading: boolean;
};

const FixedNavigation: React.FC<FixedNavigationProps> = ({
    onBack,
    isBackDisabled = false,
    isNextDisabled = false,
    onNext,
    isLoading = false,
}) => {
    const classes = useCommonModalStyles();

    return (
        <Box display="flex" alignItems="center" className={classes.nav}>
            <Box className={classes.navContent}>
                <Box>
                    <Button
                        className={classes.arrowBtn}
                        color="primary"
                        disableRipple
                        variant="outlined"
                        disabled={!onBack || isBackDisabled}
                        onClick={() => onBack?.()}
                    >
                        <KeyboardBackspaceIcon />
                    </Button>
                </Box>
                <Button
                    className={classes.outlinedBtn}
                    type="submit"
                    variant="contained"
                    disableElevation
                    disableRipple
                    color="primary"
                    disabled={isNextDisabled || isLoading}
                    onClick={() => onNext?.()}
                >
                    {isLoading && <CircularProgress size={16} color="inherit" style={{marginRight: '10px'}} />}
                    Next
                </Button>
            </Box>
        </Box>
    );
};

export default FixedNavigation;
